export default "__VITE_ASSET__CJjiBPUD__"